import { useField } from 'formik'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import { SingleRangeSlider } from '@/components/_base/SingleRangeSlider'
import { marginTop } from '@/shared-styles/styles.css'

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  className?: string
  max: number
  min: number
  name: string
  onInputBlur?: VoidFunction
  onSliderBlur?: VoidFunction
  scale: number
}

export const toInt = (text: string) => {
  return parseInt(text.replaceAll(/[€., ]/g, ''))
}

export const fixBudget = (val: number) => {
  if (val < 10) {
    return val * 10000
  }

  if (val < 1000) {
    return val * 1000
  }

  if (val < 10000) {
    return val * 10
  }

  return val
}

export const mask = createNumberMask({
  allowDecimal: false,
  allowLeadingZeroes: false,
  allowNegative: false,
  integerLimit: 8,
  prefix: '€ ',
  thousandsSeparatorSymbol: '.',
})

export const FormikPriceInputSlider: React.FC<Props> = ({
  className = '',
  max,
  min,
  name,
  onInputBlur = () => {},
  onSliderBlur = () => {},
  scale,
  ...props
}) => {
  const [field, , helpers] = useField<number>(name)
  const { value } = field
  const { setValue } = helpers

  const textInputChanged = (event) => {
    setValue(toInt(event.currentTarget.value))
  }

  const textInputBlur = (event) => {
    const val = toInt(event.currentTarget.value)
    setValue(fixBudget(val))
    onInputBlur()
  }

  return (
    <div className={className} {...props}>
      <div style={{ width: '60%' }}>
        <MaskedInput
          data-testid={name}
          id={name}
          mask={mask}
          placeholder="€"
          type="text"
          value={value || ''}
          onBlur={textInputBlur}
          onChange={textInputChanged}
        />
      </div>
      <div className={marginTop.l}>
        <SingleRangeSlider
          data-testid={`${name}-range`}
          max={max}
          min={min}
          name={name}
          scale={scale}
          value={value || min}
          onChange={setValue}
          onChangeEnd={onSliderBlur}
        />
      </div>
    </div>
  )
}
